import "../../../styles/page/order.scss";

import { TitleTab, TitleTabs } from "../../common/components/TitleTabs.jsx";

import ContentWrapper from "../../common/components/ContentWrapper";
import { Localization } from "../../common/util/localization.jsx";
import ProductionCard from "./ProductionCard";
import PropTypes from "prop-types";
import React from "react";
import { scssVariables } from "../../common/util/config.jsx";
import { withRouter } from "react-router-dom";

class DominosPage extends React.PureComponent {
    constructor(props) {
        super(props);

        this.calculateProductDisplayWidth = this.calculateProductDisplayWidth.bind(this);
    }

    UNSAFE_componentWillMount() {
        const {
            getOrdersForDoughProducts,
        } = this.props;
        getOrdersForDoughProducts();
    }

    calculateProductDisplayWidth() {
        const {
            deviceType,
            width,
        } = this.props;

        let productDisplayWidth = width;
        if (deviceType === "xs") {
            // Page padding
            productDisplayWidth -= parseInt(scssVariables[`${deviceType}ContentPadding`]) * 2;

            // Product display padding
            productDisplayWidth -= parseInt(scssVariables.cardMargin) * 2;
        } else {
            // Page padding
            productDisplayWidth -= parseInt(scssVariables[`${deviceType}ContentPadding`]); // No padding on the right side(Attached to it)

            // Product display padding
            productDisplayWidth -= parseInt(scssVariables.cardMargin) * 2;
        }

        return productDisplayWidth;
    }


    render() {
        const {
            deviceType,
            height,
            localization,
            setModal,
            customers,
            createAddressLabels,
            updateNoOfDollies,
            creating,
            selectCustomer,
            getOrdersForDoughProducts,
            loading,
        } = this.props;

        const productDisplayWidth = this.calculateProductDisplayWidth();

        return (
            <ContentWrapper height={height} paddingRight={false}>
                <div style={{ display: "flex", height: "100%" }} >
                    <div className="my-list-left-backgorund" >
                        <TitleTabs>
                            <TitleTab label={localization.text("dominos", "menu", "production")} url={"/dominosweb/production"} urlTest="/dominosweb/production" deviceType={deviceType} />
                        </TitleTabs>                    
                        <ProductionCard
                            deviceType={deviceType}
                            height={height}
                            localization={localization}
                            setModal={setModal}
                            width={productDisplayWidth}
                            customers={customers}
                            createAddressLabels={createAddressLabels}
                            updateNoOfDollies={updateNoOfDollies}
                            creating={creating}
                            loading={loading}
                            selectCustomer={selectCustomer}
                            getOrdersForDoughProducts={getOrdersForDoughProducts}
                        />
                    </div>
                </div>
            </ContentWrapper>);
    }
}

DominosPage.propTypes = {
    deviceType: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    localization: Localization.propTypes.isRequired,
    setModal: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    startView: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    getOrdersForDoughProducts:  PropTypes.func.isRequired,
    customers: PropTypes.object.isRequired,
    createAddressLabels: PropTypes.func.isRequired,
    updateNoOfDollies: PropTypes.func.isRequired,
    creating: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    selectCustomer: PropTypes.func.isRequired,
};

export default withRouter(DominosPage);
